import { Controller } from '@hotwired/stimulus'

// Keyboard shortcuts for GDS Web QA prev/next navigation.
export default class extends Controller {
  static targets = ['prev', 'next']

  connect () {
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener('keydown', this.onKeydown)
  }

  disconnect () {
    document.removeEventListener('keydown', this.onKeydown)
  }

  onKeydown (event) {
    if (event.target.matches('input, textarea, select')) return
    if (event.altKey || event.metaKey || event.ctrlKey) return

    if (event.key === 'ArrowLeft' && this.hasPrevTarget) {
      event.preventDefault()
      this.prevTarget.click()
    } else if (event.key === 'ArrowRight' && this.hasNextTarget) {
      event.preventDefault()
      this.nextTarget.click()
    }
  }
}
